import React, { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { loginRequest } from '../auth/authConfig';

const LoginButton = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [isRedirecting, setIsRedirecting] = useState(false);

  const handleLogin = () => {
    instance.loginPopup(loginRequest).catch(e => {
      console.error('Login failed:', e);
    });
  };

  const handleDemoMode = () => {
    navigate('/map/demo');
  };

  const handleEscapeToDemo = () => {
    setIsRedirecting(true);
    setTimeout(() => {
      // Navigate to demo but keep /map in history so back button works
      navigate('/map/demo', { replace: false });
    }, 2500); // Show message for 2.5 seconds before redirecting
  };

  // Handle escape key to go to demo mode
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        handleEscapeToDemo();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  // Handle background click to go to demo mode
  const handleBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      handleDemoMode();
    }
  };

  return (
    <div className="login-container" onClick={handleBackgroundClick}>
      <div className="login-card" onClick={(e) => e.stopPropagation()}>
        {isRedirecting ? (
          <div className="redirect-message">
            <h2>🎮 Redirecting to Demo Mode</h2>
            <p>Taking you to the demo...</p>
            <div className="loading-spinner"></div>
          </div>
        ) : (
          <>
            <div className="login-header">
              <h2>🌍 ShareShape</h2>
              <p>Map your SharePoint geospatial files</p>
            </div>
            
           <div className="login-content">
            <div className="requirements-note">
              <div className="note-flex">
                <span className="note-icon">⚠️</span>
                <div className="note-text">
                  <p><strong>ShareShape needs read access</strong> to your SharePoint files.</p>
                  <p>In some organizations, this may require administrator approval before you can view files.</p>
                </div>
              </div>
            </div>
         
              
              <button 
                className="btn-login" 
                onClick={handleLogin}
              >
                <span className="login-icon">🔑</span>
                Sign in with Microsoft
              </button>
              
              <button 
                className="btn-demo" 
                onClick={handleDemoMode}
              >
                <span className="demo-icon">🎮</span>
                Try Demo Mode
              </button>
              
              <div className="login-help">
                <p><strong>Supported file types:</strong></p>
                <p>GeoJSON, Shapefiles, KML, KMZ, CSV, GeoTIFF, geotagged&nbsp;photos</p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default LoginButton;